var render, staticRenderFns
import script from "./enterBox.vue?vue&type=script&lang=js"
export * from "./enterBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('508aa621')) {
      api.createRecord('508aa621', component.options)
    } else {
      api.reload('508aa621', component.options)
    }
    
  }
}
component.options.__file = "src/packages/chat/enterBox.vue"
export default component.exports